module.exports = __webpack_public_path__ + "media/images/country_flags/cd-20f42e1bdf3c5a2b3438745384210f1b.png";